<template>
  <div>
    <section class="section">
      <div class="container">
        <TituloPrincipal :titulo="titulo" :subtitulo="subtitulo"/>
        <div class="columns">
          <div class="column">
            <div class="box">
              <div class="title is-4">Casa Central - Uruguay 32</div>
              <div id="mapSucursalUno" class="mapa"></div>
              <div class="title is-5">Tel: (0343) 4221532/4225036</div>
            </div>
          </div>
        </div>
      </div>
      <Promo/>
    </section>
  </div>
</template>

<style>
.mapa {
  height: 250px;
  z-index: 0; /* Para que no tape a la nav-bar*/
}
</style>

<script>
import Promo from '@/components/Promo.vue'
import TituloPrincipal from '@/components/TituloPrincipal.vue'
import 'leaflet/dist/leaflet.js'
import 'leaflet/dist/leaflet.css'
/* global L */

export default {
  name: 'Sucursal',
  data () {
    return {
      titulo: 'Sucursal',
      subtitulo: 'Abierto al público de Lunes a Viernes de 8:30 a 12:30hs y de 16:30 a 20:30hs. Sábados de 9 a 13hs y de 16:30 a 2030hs.',
      localizacionMapaUno: [-31.73045, -60.52872],
      localizacionMapaDos: [-31.73217, -60.53]
    }
  },
  components: {
    Promo,
    TituloPrincipal
  },
  mounted () {
    this.$nextTick(() => {
      var myIcon = L.icon({
        iconUrl: require('@/assets/img/maps/marker.png'),
        iconSize: [50, 50],
        iconAnchor: [50, 50],
        popupAnchor: [0, -40]
      })

      var map = L.map('mapSucursalUno').setView(this.localizacionMapaUno, 17)

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: ''
      }).addTo(map)

      L.marker(this.localizacionMapaUno, { icon: myIcon })
        .addTo(map)
        .bindPopup('Central')
        .openPopup()
    })
  }
}
</script>
